import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgConfirmed = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M7.667 12.833L4.45 9.616a.4.4 0 00-.566 0l-.601.601a.4.4 0 000 .566l4.1 4.1a.4.4 0 00.567 0l9.434-9.433a.4.4 0 000-.566l-.601-.601a.4.4 0 00-.566 0l-8.55 8.55z" />
    </Icon>
  );
};

export default SvgConfirmed;
